module.exports = __webpack_public_path__ + "static/media/icon_users.ee3257d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_users.svg
// module id = 708
// module chunks = 0